import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { CommonService } from '../../Model/Common/common.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { ComboService } from '../../Model/Combo/combo.service';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { EmpchangepasswordService } from '../../Model/empchangepassword/empchangepassword.service';
import { AlertSuccessComponent } from '../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';

@Component({
  selector: 'app-empchangepassword',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule, LoaderComponent],
  templateUrl: './empchangepassword.component.html',
  styleUrl: './empchangepassword.component.scss'
})
export class EmpchangepasswordComponent {
  isDisabled: boolean = false;

  Detail = {
    SelectType: 'MobileNo',
    EmpMasterID: null,
    OldPassword: null,
    NewPassword: null,
    ConfirmPassword: null,
    By: null,
    Code: null,
    EmpType: 'front',
    EmployeeName: null
  }
  constructor(
    private toast: ToastService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private combo: ComboService,
    private modalService: NgbModal,
    private empchangepasswored: EmpchangepasswordService
  ) {
    this.common.getPageRights();
    // this.common.PageRight.IsView = true;
    // this.common.PageRight.IsAdd = true;
    // this.common.PageRight.IsDelete = true;
    // this.common.PageRight.IsEdit = true;
    // this.common.PageRight.IsPrint = true;
  }

  ngOnInit(): void {
    this.common.CheckExpiry();
  }

  async Save() {
    await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });

    modalRef.componentInstance.Message = 'Are you sure want to change password ?'
    modalRef.result.then((result: any) => {
      if (this.common.PageRight.IsEdit) {
        if (result) {
          this.isDisabled = true;
          this.empchangepasswored.Ess_ChangePassword(this.Detail).subscribe({
            next: (response) => {
              if (response.Error_Code == '01') {
                this.isDisabled = false
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.Detail = {
                      SelectType: 'MobileNo',
                      EmpMasterID: null,
                      OldPassword: null,
                      NewPassword: null,
                      ConfirmPassword: null,
                      By: null,
                      Code: null,
                      EmpType: 'front',
                      EmployeeName: null
                    }
                  }
                });
              }
              else {
                this.isDisabled = false;
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => {
      // Modal dismissed
    });
  }

  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    if (this.Detail.Code === null) {
      this.toast.show({ message: 'Please enter Employee Code!', type: toastTypeEnum.warning });
      return;
    }
    this.isDisabled = true
    this.combo.ComboLoad({
      'Combotype': Combotype,
      'EmpType': this.Detail.EmpType,
      'EmpCode': this.Detail.Code
    }).subscribe({
      next: (response) => {
        if (Combotype == 'ChangePassword') {
          if (response.ComboLoad.length > 0) {
            this.Detail.EmployeeName = response.ComboLoad[0].EmployeeName
            this.Detail.EmpMasterID = response.ComboLoad[0].EmpMasterID
          }
          else {
            this.Detail.EmployeeName = null
            this.toast.show({ message: 'No Data found!', type: toastTypeEnum.warning });
            return;
          }
        }
        this.isDisabled = false
      },
      complete: () => {
        this.isDisabled = false
      },
      error: (error) => {
      },
    });
  }

  Clear(IsCodeClear = true) {
    if (IsCodeClear) {
      this.Detail.Code = null;
    }
    this.Detail.EmployeeName = null;
    this.Detail.EmpMasterID = null;
  }
}
